import React from "react";
import { Tooltip } from "@mui/material";
import { ChevronsRight } from "lucide-react";

const CollapsedSidebarHeader = ({
  onToggleCollapse,
  collapseAriaLabel,
  collapseTooltipLabel,
  collapseTooltipPlacement = "left",
  isCollapsed,
}) => {
  return (
    <div className="collapsed-sidebar-header">
      <Tooltip title={collapseTooltipLabel} placement={collapseTooltipPlacement} arrow>
        <button
          type="button"
          className="collapsed-sidebar-expand-button sidebar-toggle-control"
          onClick={onToggleCollapse}
          aria-label={collapseAriaLabel}
          aria-expanded={!isCollapsed}
        >
          <ChevronsRight className="toggle-icon" />
        </button>
      </Tooltip>
    </div>
  );
};

export default CollapsedSidebarHeader;
